module.exports = __webpack_public_path__ + "static/media/froogle.60ab5616.png";